import { themeObject } from '../../../../lib';

export interface TruncateOrDropChainSelectFieldProps {
    control: any;
    errors: any;
    containerStyles?: any;
}

export const truncateOrDropChainSelectFieldStyles = {
    truncateOrDropContainer: {
        mt: 1,
        mx: '143.5px',
        display: 'flex',
        flexDirection: 'column',
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-track': {
            display: 'none',
        },
        '&::-webkit-scrollbar-thumb': {
            background: themeObject.palette.primary[500],
            borderRadius: '100px',
        },
        '& .MuiDialog-container': {
            backgroundColor: 'rgb(249,251,251)',
        },
    },
    truncateOrDropJobContainerWidth: {
        width: '100%',
    },
};
